export class FormValidation {
    private _formElements: NodeListOf<Element>;

    constructor(formElements: NodeListOf<Element>) {
        this._formElements = formElements;
    }

    public init() {
        if (this._formElements) {
            this._formElements.forEach(e => {
                const form = e as HTMLFormElement;
                const submitButton = form.querySelector('[data-module-form-validation-submit]');
                if (submitButton)
                {
                    submitButton.addEventListener('click', (event) => {
                        if (form.reportValidity()) {
                            form.submit()
                        }
                    });
                }
            });
        }
    }
}